var React = require('react');

function CheckInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","opacity":".5","transform":"translate(-4 -7)"},[React.createElement("path",{"d":"m0 0h34v34h-34z","key":0}),React.createElement("path",{"d":"m11.9545455 22.0298507-5.96590914-5.9552238-1.98863636 1.9850746 7.9545455 7.9402985 17.0454545-17.01492537-1.9886364-1.98507463z","fill":"#fff","fillRule":"nonzero","key":1})]));
}

CheckInline.defaultProps = {"height":"19","viewBox":"0 0 25 19","width":"25"};

module.exports = CheckInline;

CheckInline.default = CheckInline;
